import styled, { css } from 'styled-components';
import { ColorAddiBackgroundWhite, ColorAddiFeedbackSuccess, ColorAddiFontOverDark, ColorAddiGrayLighten3 } from '@addi/foundation/dist/web/colors';
import { Caption, Icons, Paragraph, Title, TertiaryButton } from '../index';
import { FontAddiWeightRegular, FontAddiWeightSemiBold } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontBase, SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
export const CheckoutHeaderContainer = styled.div `
    border-bottom: ${({ withDetails }) => withDetails ? `1px solid transparent` : `1px solid ${ColorAddiGrayLighten3}`};
    background-color: ${ColorAddiBackgroundWhite};
`;
export const CheckoutSummaryContainer = styled.div `
    height: ${({ withDiscount }) => withDiscount ? '100px' : '80px'};
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    align-items: ${({ withDiscount }) => withDiscount ? 'center' : 'start'};
    justify-content: center;
`;
export const CheckoutSummaryImage = styled.img `
    width: 44px;
    height: 44px;
    margin-right: 12px;
    align-self: center;
`;
export const CheckoutSummaryDetails = styled.div `
    flex: 1;
    display: flex;
    flex-direction: column;
`;
export const CheckoutSummaryDetailsDescription = styled(Paragraph) `
    font-size: ${SizeAddiFontXSmall};
    margin: 0;
`;
export const CheckoutSummaryDetailsSubtotalContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;
export const CheckoutSummaryDetailsSubtotalValue = styled(Title) `
    flex: 1;
    margin: 0;
    font-size: ${SizeAddiFontBase};
`;
export const CheckoutSummaryDetailsSubtotalIconContainer = styled.div `
    cursor: pointer;
`;
export const CheckoutSummaryDetailsSubtotalIcon = styled(Icons) `
    font-size: 24px;
`;
export const CheckoutBackIconContainer = styled.div `
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    margin-right: 19px;
`;
export const CheckoutBackIcon = styled(Icons) `
    font-size: 24px;
`;
export const CheckoutSummaryDetailsPurchaseContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin: 2px 0;
`;
export const CheckoutSummaryDetailsPurchaseValue = styled(Caption) `
    text-decoration: line-through;
    opacity: 0.5;
    margin: 0;
`;
export const CheckoutSummaryDetailsPercentageValue = styled(Caption) `
    background-color: ${ColorAddiFeedbackSuccess};
    font-weight: bold;
    color: ${ColorAddiFontOverDark};
    padding: 2px 10px;
    margin: 0 5px;
    border-radius: 5px;
`;
export const CheckoutButtonItems = styled(TertiaryButton) `
    padding: 0;
    align-self: start;
    min-width: 0;
`;
export const OrderDetailsContainer = styled.div `
    display: flex;
    flex-direction: column;
    left: 0;
    right: 0;
    background-color: rgba(24, 24, 31, 0.8);
    max-height: 100%;
    overflow: auto;
    z-index: 20;
`;
export const OrderDetailsList = styled.div `
    background-color: white;
    border-bottom: 1px solid ${ColorAddiGrayLighten3};
    padding: 8px 16px;
`;
export const OrderDetailsListItem = styled.div `
    margin: 0 auto;
    margin-left: 55px;
    display: flex;
    padding: 8px 0;
`;
export const OrderDetailsListItemDescription = styled(Paragraph) `
    flex: 1;
    margin: 0;
    font-weight: ${FontAddiWeightRegular};
    font-size: ${SizeAddiFontXSmall};
`;
export const OrderDetailsListItemValue = styled(Paragraph) `
    margin: 0;
    font-weight: ${FontAddiWeightSemiBold};
    font-size: ${SizeAddiFontXSmall};
    ${({ isAddiDiscount }) => isAddiDiscount && css `
        color: ${ColorAddiFeedbackSuccess};
    `}
`;
//# sourceMappingURL=checkout-header.styled.js.map